import SharedStyles from "@components/Global/Custom/ProList/@styles/ProList.styles";

export default (theme) => {
	const sharedStyles = SharedStyles(theme);

	return Object.assign(sharedStyles, {
		//
	});
};
